import i18n from "@/plugins/vue-i18n";

const News = () => import(/* webpackChunkName: "news" */ "@/views/news/index");

const NewsDetails = () => import(/* webpackChunkName: "news" */ "@/views/news/details");

const news = [
  {
    path: "/news",
    name: "News",
    component: News,
    meta: {
      title: i18n.t("title.news._"),
    },
  },
  {
    path: "/news/:id",
    name: "NewsDetails",
    component: NewsDetails,
    meta: {
      title: i18n.t("title.news.details"),
    },
  },
];

export default news;
